import React from 'react';
import ModerationContext from './moderationContext';

export default function useModerationContext() {
    const ctx = React.useContext(ModerationContext);
    if (!ctx) {
        throw new Error('[useModerationContext] Did you call useModerationContext outside an ModerationContextProvider component?');
    }

    const { moderationContext, setModerationContext, removeFromModerationContext } = ctx;

    return [moderationContext, setModerationContext, removeFromModerationContext];
}
